<template>
  <div>
    <h6
      v-if="userData === null"
      class="heading-small text-muted mb-4 text-truncate"
    >
      Add User
    </h6>
    <h6 v-else class="heading-small text-muted mb-4 text-truncate">
      Edit User
    </h6>

    <form id="form-proper">
      <a-tabs :default-active-key="defaultTab">
        <a-tab-pane key="user-info" tab="User Information">
          <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
            <div class="row">
              <div class="col">
                <base-input label="User Group" required>
                  <a-select
                    v-model="$v.formData.user_group_id.$model"
                    :disabled="viewMode"
                  >
                    <a-select-option
                      v-for="userGroup in options.userGroups"
                      v-bind:value="userGroup.id"
                      v-bind:key="userGroup.id"
                    >
                      {{ userGroup.name }}
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.user_group_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.user_group_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input
                    v-model="$v.formData.name.$model"
                    :disabled="viewMode || isNonBxi"
                  />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row" v-if="userData === null">
              <div class="col">
                <base-input label="Username" required>
                  <a-input
                    v-model="$v.formData.username.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.username.$dirty" class="text-danger">
                    <div
                      class="error"
                      v-if="!$v.formData.username.required && userData === null"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row" v-if="userData === null">
              <div class="col">
                <base-input label="Password" required>
                  <a-input-password
                    v-model="$v.formData.password.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.password.$dirty" class="text-danger">
                    <div
                      class="error"
                      v-if="!$v.formData.password.required && userData === null"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Email" required>
                  <a-input
                    v-model="$v.formData.email.$model"
                    :disabled="viewMode || isNonBxi"
                  />
                  <div v-if="$v.formData.email.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.email.required">
                      Field is required
                    </div>
                    <div class="error" v-if="!$v.formData.email.email">
                      Please enter valid email
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
          </div>
        </a-tab-pane>
        <!-- Visiting sites -->
        <a-tab-pane key="visiting-sites" tab="Visiting Sites" force-render>
          <div class="row">
            <div class="col">
              <base-input label="Default Site" required>
                <b-form-select
                  v-if="options.visiting_sites.length > 0"
                  v-model="formData.default_site"
                  class="mb-3"
                  :disabled="viewMode || isNonBxi"
                >
                  <b-form-select-option
                    v-for="site in options.visiting_sites"
                    :key="site.id"
                    v-model="site.id"
                    >{{ site.name }}</b-form-select-option
                  >
                </b-form-select>
                <div v-else>Please select Visiting Sites</div>
                <div v-if="$v.formData.default_site.$dirty" class="text-danger">
                  <div class="error" v-if="!$v.formData.default_site.required">
                    Field is required
                  </div>
                </div>
              </base-input>
            </div>
          </div>
          <div>
            <b-form-group>
              <b-form-checkbox
                v-for="site in options.sites"
                v-model="formData.visiting_sites"
                :key="site.id"
                :value="site.id"
                name="visiting_sites"
                :disabled="viewMode || isNonBxi"
              >
                {{ site.name }}
              </b-form-checkbox>
            </b-form-group>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="userData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createUser"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editUser"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email, requiredIf } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';
import secureStorage from '@/controllers/secureStorage';

export default {
  name: 'UserForm',
  props: {
    userData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      source: secureStorage.getItem('source'),
      defaultTab: 'user-info',
      formData: {
        name: null,
        email: null,
        username: '',
        password: '',
        user_group_id: null,
        visiting_sites: [],
        default_site: null
      },
      options: {
        userGroups: [],
        sites: [],
        visiting_sites: []
      }
    };
  },

  validations: {
    formData: {
      user_group_id: {
        required
      },

      username: {
        required: requiredIf(function () {
          return this.userData === null;
        })
      },
      password: {
        required: requiredIf(function () {
          return this.userData === null;
        })
      },
      name: { required },
      email: { required, email },
      default_site: { required }
    }
  },

  methods: {
    async getUserGroup() {
      const response = await HTTPRequest.getRequest('/api/v1/user_groups');
      this.options.userGroups = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async getSites() {
      const response = await HTTPRequest.getRequest('/api/v1/sites', {
        per_page: 1000
      });
      this.options.sites = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },

    async createUser() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest('/api/v1/users', {
          user: this.formData
        });

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    async editUser() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/users/' + this.userData.id,
          {
            user: this.formData
          }
        );

        if (response.id) {
          const visitingSites = response.sites ?? [];
          if (visitingSites.length > 0) {
            secureStorage.setItem('visitingSites', visitingSites);
          }
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
          location.reload();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },
    clearForm() {
      this.formData = {
        user_group_id: null,
        name: null,
        username: null,
        password: null,
        email: null,
        visiting_sites: []
      };
      this.defaultTab = 'defaultTab';
    },
    async setFormData() {
      if (this.userData !== null) {
        let s = [];
        const { user_group_id, name, email, site_id, sites } = this.userData;
        if (sites != undefined && sites.length) {
          for (const site of sites) {
            s.push(site.id);
          }
        }
        this.formData = {
          user_group_id,
          name,
          visiting_sites: s,
          email,
          default_site: site_id
        };
        this.defaultTab = 'user-info';
      }
    }
  },

  computed: {
    isNonBxi() {
      return this.source !== 'clp' || false;
    }
  },
  someRef() {
    return this.userData !== null;
  },
  created() {
    this.getUserGroup();
    this.getSites();

    this.setFormData();
  },
  watch: {
    'formData.visiting_sites': function (val) {
      if (
        this.formData.default_site &&
        !val.includes(this.formData.default_site)
      ) {
        this.formData.default_site = null;
      }
      this.options.visiting_sites = [];
      this.options.sites.map((site) => {
        if (val.includes(site.id)) {
          this.options.visiting_sites.push(site);
        }
      });
    },
    userData: function (newVal) {
      if (newVal !== null) {
        this.setFormData();
      } else {
        this.clearForm();
      }
    },

    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  }
};
</script>

<style scoped></style>
